import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { APP } from '../config/app';
import { UserRole } from '../models/enums';
import { StorageService } from '../services';

export const roleGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const storageService = inject(StorageService);
  const router = inject(Router);
  const allowedRoles: UserRole[] = route.data['roles'] ?? [];
  const role = await storageService.getRole();
  return allowedRoles.includes(role) || router.createUrlTree([APP.DEFAULT_ROUTE]);
};
